import { isSSR } from '@k2/core/util'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApiRequest } from '@/api'
import { type BrandExtraction, type ReviewBody, useBrandExtractionsResource } from '../resources'
import { useBrandKitStore } from './brand-kit.store'

const CLIENT = !isSSR

export const useBrandExtractionsStore = defineStore('brand-extractions', () => {
  const { getBrandExtractions, setBrandExtraction, setBrandExtractionReview } = useBrandExtractionsResource()
  const { run, loading, failure } = useApiRequest()

  const extractions = ref<Record<string, BrandExtraction[]>>({})

  const loadExtractions = async (organizationId: string, brandId: string) => {
    if (!CLIENT) return
    const rows = await run<BrandExtraction[]>(() => getBrandExtractions(organizationId, brandId))
    if (rows) extractions.value = { ...extractions.value, [brandId]: rows }
    return rows
  }

  const extract = (organizationId: string, brandId: string, sourceUrl: string) =>
    run(() => setBrandExtraction(organizationId, brandId, sourceUrl))

  const review = async (organizationId: string, brandId: string, extractionId: string, body: ReviewBody) => {
    const result = await run(() => setBrandExtractionReview(organizationId, brandId, extractionId, body))
    if (result) {
      const kitStore = useBrandKitStore()
      await kitStore.loadKit(organizationId, brandId)
      await loadExtractions(organizationId, brandId)
    }
    return result
  }

  return { extractions, loading, failure, loadExtractions, extract, review }
})
